import { ChainId, ETHER } from '@uniswap/sdk-core'
import React, { useEffect, useState } from 'react'
import { Text } from 'rebass'

import styled from 'styled-components'

import LogoDark from '../../assets/logo-white.svg'
import LogoWhite from '../../assets/logo-full-white.svg'

import Wordmark from '../../assets/wordmark_white.svg'
import WordmarkWhite from '../../assets/wordmark_full-white.svg'

import { useActiveWeb3React } from '../../hooks'
import { useETHBalances } from '../../state/wallet/hooks'

import { YellowCard } from '../Card'

import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'

import CurrencyLogo from 'components/CurrencyLogo'
import MenuV2Desktop from './Menu/MenuV2Desktop'
import MenuV2 from './Menu/MenuV2'
import { CURRENT_CHAIN } from '@hyperswap/addresses'

const HeaderFrame = styled.div<{ scrolled: boolean }>`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  padding: 1rem;
  z-index: 21;
  position: relative;
  transition: background ease 500ms;
  background: ${({ scrolled }) => {
      return scrolled ? '#121212e6' : 'transparent'
    }}
    ${({ theme }) => theme.mediaWidth.upToMedium`
    padding:  1rem;
    grid-template-columns: 1fr 1fr;

  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 1rem;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  /* addresses safari's lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

const HeaderRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
   width: 100%;
  `};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgb(7, 39, 35);
  border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
`

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  border-radius: 12px;
  padding: 8px 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgb(80, 210, 193);
`

export const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  text-decoration: none;

  span {
    font-size: 8px;
    font-family: Unbounded;
    margin-left: 2px;
    margin-top: 6px;
    opacity: 1;
    transition: opacity ease 200ms;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  /* :hover {
    cursor: pointer;
    span {
      opacity: 1;
    }
  } */
`

export const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg2};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`
export const TitleText = styled(Row)`
  width: fit-content;
  white-space: nowrap;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.HYPEREVM_TESTNET]: '',
}

export default function Header() {
  const { account, chainId } = useActiveWeb3React()
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10) // Change threshold as needed
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']

  const isTestnet = (CURRENT_CHAIN as unknown) === ChainId.HYPEREVM_TESTNET

  return (
    <HeaderFrame scrolled={scrolled}>
      <HeaderRow>
        <Title href=".">
          <UniIcon>
            <img width={'24px'} src={isTestnet ? LogoWhite : LogoDark} alt="logo" />
          </UniIcon>
          <TitleText>
            <img
              style={{ marginLeft: '6px', width: '7rem' }}
              src={isTestnet ? WordmarkWhite : Wordmark}
              alt="logo wordmark"
            />
          </TitleText>
          <span style={{ color: isTestnet ? 'white' : 'inherit' }}>beta</span>
          {/* <span>v{process.env.REACT_APP_VERSION}</span> */}
        </Title>
        <MenuV2Desktop />
      </HeaderRow>
      <HeaderControls>
        <HeaderElement>
          <HideSmall>
            {chainId && NETWORK_LABELS[chainId] && (
              <NetworkCard title={NETWORK_LABELS[chainId]}>{NETWORK_LABELS[chainId]}</NetworkCard>
            )}
          </HideSmall>

          <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                {userEthBalance?.toSignificant(4)} <CurrencyLogo currency={ETHER} />
              </BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
        <MenuV2 />
      </HeaderControls>
    </HeaderFrame>
  )
}
